import React from 'react';

import styled from '@emotion/styled';

import PageLayout from '../../../components/Layout/PageLayout';
import Page from '../../../components/Page/Page';
import Table from '../../../components/Table/Table';
import TableDateFormatter from '../../../components/Table/TableAccessories/TableDateFormatter';
import Export from './Export';

const WaitlistSubmissions = () => {
  return (
    <Page title='Logirate | Waitlist Submissions'>
      <PageLayout noTitle={true}>
        <Container>
          <Table
            // border
            tableTitle='WAITLIST'
            tableFilterBoxFeatures={{
              rightAttr: [
                {
                  type: 'regular',
                  comp: <Export />,
                },
              ],
            }}
            tableHeader={{
              Timestamp: 'createdAt',
              'First Name': 'firstName',
              'Last Name': 'lastName',
              'Email Address': 'email',
            }}
            tableDataSourceUrl='ba/v1/waitlist'
            cellsCustomComp={{
              createdAt: <TableDateFormatter dataKey='createdAt' />,
            }}
          />
        </Container>
      </PageLayout>
    </Page>
  );
};

export default WaitlistSubmissions;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;
